import React from "react";
import SimpleToggleButton from "../../../common/SimpleToggleButton/SimpleToggleButton";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TenantCard = ({ tenant, onToggleActive, updatingTenantCode }) => {
  const { t } = useTranslation();

  const { name, code, type, is_active } = tenant;

  const navigate = useNavigate();

  const handleCardClick = (event) => {
    if (event.target.closest("[data-toggle-action]")) return;
    navigate(`/issuer/tenant/${code}/organisations/users`);
  };

  return (
    <div
      id={`tenant-card-${code}`}
      className="flex flex-row items-center border rounded-[var(--cf-issued-credential-border-radius)] py-[var(--cf-issued-credential-template-card-padding-y)] px-6 hover:bg-[#F9FAFB] min-h-[5rem] min-w-[78.8rem] cursor-pointer"
      onClick={handleCardClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleCardClick(e);
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="w-1/5 text-center min-w-[200px] flex-shrink-0 overflow-hidden">
        <p className="text-cfHeadingText whitespace-nowrap truncate">{name}</p>
      </div>
      <div className="w-1/5 text-center min-w-[150px] flex-shrink-0 overflow-hidden">
        <p className="text-cfHeadingText truncate">{code}</p>
      </div>
      <div className="w-1/5 text-center min-w-[150px] flex-shrink-0 overflow-hidden">
        <p className="text-cfHeadingText truncate">{type}</p>
      </div>
      <div className="w-1/5 text-center min-w-[120px] flex-shrink-0 overflow-hidden">
        <span
          className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
            is_active
              ? "bg-cfIssuedCredentialTemplateCardStatusDoneBG text-cfIssuedCredentialTemplateCardStatusText"
              : "bg-cfIssuedCredentialTemplateCardStatusRevokedBG text-white"
          }`}
        >
          {is_active ? t("tenant:active") : t("tenant:inactive")}
        </span>
      </div>
      <div
        data-toggle-action
        className={`w-1/5 text-center min-w-[120px] flex-shrink-0 overflow-hidden flex justify-center items-center ${
          updatingTenantCode === code ? "cursor-not-allowed" : "cursor-default"
        }`}
      >
        <div className="relative inline-flex items-center">
          <SimpleToggleButton
            checked={is_active}
            onChange={() => onToggleActive(tenant)}
            disabled={updatingTenantCode === code}
            testId={`tenant-card-toggle-active-${code}`}
            ariaLabel={t("tenant:toggle_status_for", { name })}
          />
        </div>
      </div>
    </div>
  );
};

export default TenantCard;
